import React from "react";
import "./Shibir_inner.css";
import Common_Back_Header from "../../../../common/common_components/common_back_header/Common_Back_Header";
import Latest_Articles from "../../../../insight/latest_articles/Latest_Articles";
import Latest_Videos from "../../../../insight/latest_videos/Latest_Videos";
import Latest_Audio from "../../../../insight/latest_audio/Latest_Audio";
import Common_Title_2 from "../../../../common/common_components/common_title_2/Common_Title_2";
import Inner_Calm from "../../../../home/inner_calm/Inner_Calm";
import Floating_Note from "../floating_note/Floating_Note";
import { useNavigate } from "react-router-dom";

const Shibir_inner = () => {

    const navigate = useNavigate()

  return (
    <>
      <section className="Shibir_inner_Sec">
        <div className="container">
          <Common_Back_Header backNavigation={-1} />

          <div class="Common_Title_1">
            <div class="row justify-content-center">
              <div class="col-8 mx-auto text-center">
                <p class="sub_text">My Practice Today</p>
              </div>
            </div>
          </div>

          <Inner_Calm />
          <Latest_Articles />

          <Common_Title_2 subText={"Pravachan"} />

          <Latest_Videos />
          <Latest_Audio />

          <Floating_Note label="Sankalp Notes" onClick={() => navigate("/sankalp-notes")}/>
        </div>
      </section>
    </>
  );
};

export default Shibir_inner;
